import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/equi-trip/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_trip text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/equi-trip/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={183}
                height={152}
              />
            </div>
            <p>
              Equitrip is a digital platform for horse owners, horse
              transportation companies, and other industry stakeholders to
              connect and collaborate to make horse transport convenient.
            </p>
            <p>
              TekRevol was entrusted with working on this one-of-a-kind project,
              where our teams built the complete solution for the client,
              bringing all the critical stakeholders of equestrian transport
              together and providing them with the right features and
              functionalities.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/banner_mobile.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={627}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
